import * as React from "react";
import * as _ from "lodash";
import {Dropdown} from "@bizform/primereact/components/dropdown/Dropdown";
import {InputText} from "@bizform/primereact/components/inputtext/InputText";
import {InputTextarea} from "@bizform/primereact/components/inputtextarea/InputTextarea";
import {Button} from "@bizform/primereact/components/button/Button";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {DataType} from "@bizform/type/model/model/DataType.model";
import {ExceptionType} from "@bizform/type/model/model/Exception.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty,
    ComponentElementPropertyEvent
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {LookUp} from "@bizform/type/model/data_type/LookUp.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {DataTable} from "@bizform/primereact/components/datatable/DataTable";
import {Column} from "@bizform/primereact/components/column/Column";
import {
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic
} from "@bizform/type/model/component_element/ComponentElement.model";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";
import {RequestFileUpdate, ResponseFileGetList} from "@bizform/type/model/rest_api/File.model";
import {WrongRequest} from "@bizform/type/model/rest_api/_BaseRestApi.model";
import {DoGridAction, GridIdKeyConstant} from "@bizform/type/model/component_element/manifest_constant/Grid.constant";
import {FormContentConditionName} from "@bizform/type/model/form/FormContent.model";
import {
    AccessibilityDropdown,
    Debug,
    DomHelper,
    FileHelper,
    FunctionHelper,
    ObjectHelper,
    StringHelper
} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    ApiFile,
    BlockHandler,
    ComponentElementClass,
    DataStorage,
    ExceptionHandler,
    FormDataSchemaService,
    FormStateService,
    GridActionService,
    GridDataService,
    GridSchemaService,
    I18N,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";


type Props =  {
};

type State =  {
    show: boolean;
    [GridIdKeyConstant]?: string;
    fileList?: Array<any>;
    lookup?: Array<LookUp>;
    rows?: number;
    property?: ComponentElementProperty;
    displayMode?: ComponentElementDisplayMode;
    sortField?: string;
    sortOrder?: number;
    category?: string;
    name?: string;
    title?: string;
    pageNo?: number;
    first?: number;
    totalCount?: number;
    orderBy?: string;
    autoLayout?: boolean;
    emptyMessage?: string;
};

/**
 * Embed Form component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfFileList extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.COMPONENTELEMENT;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_kUASNn0z40vUVF6UgFykwUN3OtCagky",
        category: ComponentCategory.FILE,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "File List",
        description: "File List",
        icon: "",
        dataType: [DataType.FILE],
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    parentDom: HTMLElement;

    /** action */
    emit(value: any) {}
    subscription(value: any, entityId?: string) {
        if (!this._isGrid) {
            if (!this._uploadLength) {
                this._uploadLength = 0;
            }
            if (value && value.length !== this._uploadLength && this.state.property.attribute.auto) {
                this._uploadLength = value.length;
                this._onReload();
            }
        } else {
            if (entityId) {
                this._entityId = entityId;
                this.setState({
                    fileList: value,
                    pageNo: 1,
                    totalCount: value.length
                }, this._doneReload);
            } else {
                this._onReload();
            }
        }
    }
    emitDidCatch(error: Error | any): void {
        this.emitDidCatch(error);
    }

    onDisabled() {
        this._show(ComponentElementDisplayMode.DISABLED);
    }
    onReadOnly() {
        this._show(ComponentElementDisplayMode.READONLY);
    }
    onPrint() {
        this._show(ComponentElementDisplayMode.READONLY);
    }
    onEdit() {
        this._show(ComponentElementDisplayMode.EDIT);
    }

    focus() {}

    readyComponent() {}

    setProperty(property: ComponentElementProperty) {
        if (!this._queryString) {
            this._queryString = JSON.stringify(FormStateService.getQueryString(this.applicationId, this.formId));
        }
        try {
            this._clearCallback();
            this._initCallback(property.event);
            property.attribute.paginator.value = property.attribute.paginator.value ? true : null;
            if (!property.attribute.className) {
                property.attribute.className = {value: []};
            }
            if (!property.attribute.style) {
                property.attribute.style = {value: {}};
            }
            const s = ["table", "header", "body", "footer"];
            for (const key in s) {
                if (!property.attribute[s[key] + "ClassName"]) {
                    property.attribute[s[key] + "ClassName"] = {value: []};
                }
                if (!property.attribute[s[key] + "Style"]) {
                    property.attribute[s[key] + "Style"] = {};
                }
            }
            this.setState({
                show: this.state.show,
                fileList: [],
                property: property
            });
        } catch (e) {
            this.emitDidCatch(e);
        }
    }

    // 코어에서 [] 보장됨
    lookupDataSubscription?(lookup: Array<LookUp>): void {
        this.setState({
            lookup: lookup
        });
    }

    @ReactComponentElementInit(BfFileList)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this._element = null;
        this._clearCallback();
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    private _element: HTMLInputElement;
    private _lCallback: Function;
    private _queryString: string;
    private _uploadLength: number;
    private _init: boolean;
    private _editData: any;
    private _isGrid: boolean;
    private _entityId: string;

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false,
            pageNo: 1,
            lookup: [],
            fileList: [],
            sortField: "id",
            orderBy: "id DESC"
        };
        this._onTitle = this._onTitle.bind(this);
        this._onName = this._onName.bind(this);
        this._onCategory = this._onCategory.bind(this);
        this._onSearch = this._onSearch.bind(this);
        this._onClear = this._onClear.bind(this);
        this._onReload = this._onReload.bind(this);
        this._onSort = this._onSort.bind(this);
        this._onPage = this._onPage.bind(this);
        this._onEdit = this._onEdit.bind(this);
        this._onEditCancel = this._onEditCancel.bind(this);
        this._onUpdate = this._onUpdate.bind(this);
        this._onDownload = this._onDownload.bind(this);
        this._onDelete = this._onDelete.bind(this);
        this._onUpdateTitle = this._onUpdateTitle.bind(this);
        this._onUpdateCategory = this._onUpdateCategory.bind(this);
        this._onUpdateDescription = this._onUpdateDescription.bind(this);
        this._successList = this._successList.bind(this);
        this._catchException = this._catchException.bind(this);
        this._catchCommonException = this._catchCommonException.bind(this);
        this._titleTemplate = this._titleTemplate.bind(this);
        this._nameTemplate = this._nameTemplate.bind(this);
        this._categoryTemplate = this._categoryTemplate.bind(this);
        this._sizeTemplate = this._sizeTemplate.bind(this);
        this._descriptionTemplate = this._descriptionTemplate.bind(this);
        this._actionTemplate = this._actionTemplate.bind(this);
        this._setRef = this._setRef.bind(this);
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        const props = (this as any).___props;
        if (!this.state.show) {
            return null;
        } else if ((this.state.property.extend && !this.state.property.extend.list) || (!props || !props.data || !props.data.dataField)) {
            return (
                <div className="bf-data-wrap p-0">
                    <div className="bf-drag p-1">
                        <div className="m-0 p-3 text-center bf-text-gray6" style={{fontSize: "1.5rem"}}>
                            {!props || !props.data || !props.data.dataField ? "Need to Link with File Entity" : "Need List API"}
                        </div>
                    </div>
                </div>
            );
        } else {
            const s = this._entityId ? FormDataSchemaService.getProjectDataSchemaFieldData(this.applicationId, this._entityId, true) : null;
            this._isGrid = GridSchemaService.hasGIds(this.applicationId, props);
            const a = this.state.property.attribute;
            const sortable = a.sortable.value;
            const sortField = sortable ? (this.state.sortField ? this.state.sortField : "Num") : null;
            const sortOrder = sortable ? (this.state.sortOrder ? this.state.sortOrder : -1) : null;
            const first = a.paginator.value && this.state.pageNo ? (this.state.pageNo - 1) * a.rows.value : 0;
            return (
                <React.Fragment>
                    {this._search()}
                    <DataTable
                        ref={this._setRef}
                        key={this.elementId}
                        lazy={this._isGrid ? false : true}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        paginator={a.paginator.value}
                        rows={a.rows.value}
                        pageLinkSize={a.pageLinkSize.value}
                        first={first}
                        totalRecords={this.state.totalCount}
                        emptyMessage={this.state.emptyMessage}
                        autoLayout={this.state.autoLayout}
                        style={a.style.value}
                        className={a.className.value.join(" ")}
                        tableStyle={a.tableStyle.value}
                        tableClassName={a.tableClassName.value.join(" ")}
                        resizableColumns={a.resizableColumns.value  ? true : false}
                        onSort={this._onSort}
                        onPage={this._onPage}
                        value={this.state.fileList}
                    >
                        <Column key="id" field="id" header="Id" sortable={sortable}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={a.headerStyle.value}
                                bodyClassName={a.bodyClassName.value.concat(["text-right"]).join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        />
                        <Column key="fileName" field="name" header="File Name" sortable={sortable}
                                body={this._nameTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={a.headerStyle.value}
                                bodyClassName={a.bodyClassName.value.join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        />
                        <Column key="fileSize" field="fileSize" header="Size" sortable={sortable}
                                body={this._sizeTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={a.headerStyle.value}
                                bodyClassName={a.bodyClassName.value.join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        />
                        <Column key="title" field="title" header="Title" sortable={sortable}
                                body={this._titleTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={a.headerStyle.value}
                                bodyClassName={a.bodyClassName.value.join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        />
                        {this.state.lookup && this.state.lookup.length && (!s || s.lookup && s.lookup.id) ? <Column key="category" field="category" header="Category"
                                body={this._categoryTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={_.merge({}, a.headerStyle.value)}
                                bodyClassName={a.bodyClassName.value.join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        /> : <div className="d-none"></div>}
                        {this.state.property.extend && this.state.property.extend.hasDescription && (!s || s.file.hasDescription) ? <Column key="description" field="description" header="Description"
                                body={this._descriptionTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={_.merge({}, a.headerStyle.value)}
                                bodyClassName={a.bodyClassName.value.join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        /> : <div className="d-none"></div>}
                        <Column key="action" field="action" header="Action"
                                body={this._actionTemplate}
                                headerClassName={a.headerClassName.value.join(" ")} headerStyle={_.merge({}, a.headerStyle.value, {width: "100px", maxWidth: "100px"})}
                                bodyClassName={a.bodyClassName.value.concat(["text-center"]).join(" ")} bodyStyle={a.bodyStyle.value}
                                footerClassName={a.footerClassName.value.join(" ")} footerStyle={a.footerStyle.value}
                        />
                    </DataTable>
                </React.Fragment>
            );
        }
    }

    private _show(m: ComponentElementDisplayMode) {
        this.setState({
            show: true,
            displayMode: m
        }, this._firstLoad);
    }

    private async _firstLoad(): Promise<void> {
        if (!this._init) {
            if (!this._isGrid) {
                this._onReload();
            }
            this._init = true;
        }
    }

    private _setRef(ref) {
        if (ref) {
            this._element = ref.table;
            this.readyComponent();
        }
    }

    private _titleTemplate(data: any, info: any): React.ReactNode {
        if (this.state.displayMode === ComponentElementDisplayMode.EDIT && data._edit) {
            return (
                <InputText
                    value={data[info.field]}
                    bf-data-value={data.id}
                    placeholder="Enter a title..."
                    onChange={this._onUpdateTitle}
                    autoFocus={true}
                />
            );
        } else {
            const className = this.state.displayMode !== ComponentElementDisplayMode.PRINT ? "text-truncate" : "text-break";
            return (
                <div className={className} title={data[info.field]}>{data[info.field]}</div>
            );
        }
    }

    private _nameTemplate(data: any, info: any): React.ReactNode {
        const className = this.state.displayMode !== ComponentElementDisplayMode.PRINT ? "text-truncate bf-cursor-pointer" : "text-break bf-cursor-pointer";
        return this.state.displayMode !== ComponentElementDisplayMode.DISABLED ? (
            <a tabIndex={0} bf-data-value={data.id} onClick={this._onDownload} onKeyDown={this._onDownload} className={className} title={data[info.field]} style={{display: "block"}}>{data[info.field]}</a>
        ) : (
            <div className={className} title={data[info.field]} style={{display: "block"}}>{data[info.field]}</div>
        );
    }

    private _categoryTemplate(data: any, info: any): React.ReactNode {
        const category = data[info.field] ? JSON.parse(data[info.field]) : null;
        if (this.state.displayMode === ComponentElementDisplayMode.EDIT && data._edit) {
            const value = category && category.value ? category.value : null;
            return this.accessibility ?
                <AccessibilityDropdown
                    key={this.elementId + "_" + data.id}
                    id={this.elementId + "_" + data.id}
                    value={value}
                    options={this.state.lookup}
                    placeholder="Select a Category"
                    showClear={false}
                    isMultiple={false}
                    displayMode={this.state.displayMode}
                    onChange={this._onCategory}
                />
                :
                <Dropdown
                    key={this.elementId + "_" + data.id}
                    id={this.elementId + "_" + data.id}
                    value={value}
                    options={this.state.lookup}
                    appendTo={DomHelper.getForOverLayDom()}
                    style={{ minWidth: "100px" }}
                    onChange={this._onUpdateCategory}
                    placeholder="Select a Category"
                    filter={true}
                    filterBy="label,value"
                />;
        } else {
            const value: string = category && category.label ? category.label : "";
            const className = this.state.displayMode !== ComponentElementDisplayMode.PRINT ? "text-truncate text-center" : "text-break text-center";
            return (
                <div className={className} title={value}>{value}</div>
            );
        }
    }

    private _sizeTemplate(data: any, info: any): React.ReactNode {
        const className = this.state.displayMode !== ComponentElementDisplayMode.PRINT ? "text-truncate text-right" : "text-right";
        const value = FileHelper.transform(data[info.field]);
        return (
            <div className={className} title={value}>{value}</div>
        );
    }

    private _descriptionTemplate(data: any, info: any): React.ReactNode {
        if (this.state.displayMode === ComponentElementDisplayMode.EDIT && data._edit) {
            return (
                <InputTextarea
                    value={data[info.field]}
                    bf-data-value={data.id}
                    placeholder="Enter a description..."
                    onChange={this._onUpdateDescription}
                />
            );
        } else {
            const className = this.state.displayMode !== ComponentElementDisplayMode.PRINT ? "text-truncate" : "text-break";
            return (
                <div className={className} title={data[info.field]}>{data[info.field]}</div>
            );
        }
    }

    private _actionD(data: any, info: any, only?: boolean) {
        return !data._edit ? <Button
            icon="fas fa-download"
            value={data.id}
            className="p-button-primary"
            style={{width: only ? "90%" : "calc(33% - 0.2rem)", marginRight: "0.2rem", height: "1.5rem", lineHeight: "1.5rem"}}
            tooltip={I18N.translate("{$I._app.accessibility.component.fileList.doDownload}")}
            onClick={this._onDownload}
            aria-label={I18N.translate("{$I._app.accessibility.component.fileList.doDownload}")}
            disabled={(this as any).___props.preMode === FormContentConditionName.DISABLED}
        /> : null;
    }

    private _actionE(data: any, info: any) {
        return !data._edit && this.state.property.extend && this.state.property.extend.update && (this as any).___props.preMode === FormContentConditionName.EDITABLE ? <Button
            icon="fas fa-edit"
            value={data.id}
            className="p-button-primary"
            style={{width: "calc(33% - 0.2rem)", marginRight: "0.2rem", height: "1.5rem", lineHeight: "1.5rem"}}
            tooltip={I18N.translate("{$I._app.accessibility.component.fileList.doEdit}")}
            onClick={this._onEdit}
            aria-label={I18N.translate("{$I._app.accessibility.component.fileList.doEdit}")}
        /> : null;
    }

    private _actionR(data: any, info: any) {
        return !data._edit && this.state.property.extend && this.state.property.extend.delete && (this as any).___props.preMode === FormContentConditionName.EDITABLE ? <Button
            icon="fas fa-trash-alt"
            value={data.id}
            className="p-button-danger"
            style={{width: "calc(33% - 0.2rem)", height: "1.5rem", lineHeight: "1.5rem"}}
            tooltip={I18N.translate("{$I._app.accessibility.component.fileList.doDelete}")}
            onClick={this._onDelete}
            aria-label={I18N.translate("{$I._app.accessibility.component.fileList.doDelete}")}
        /> : null;
    }

    private _actionU(data: any, info: any) {
        return data._edit ? <Button
            icon="fas fa-save"
            value={data.id}
            className="p-button-primary"
            style={{width: "calc(50% - 0.2rem)", marginRight: "0.2rem"}}
            tooltip={I18N.translate("{$I._app.accessibility.component.fileList.doUpdate}")}
            onClick={this._onUpdate}
            aria-label={I18N.translate("{$I._app.accessibility.component.fileList.doUpdate}")}
        /> : null;
    }

    private _actionC(data: any, info: any) {
        return data._edit ? <Button
            icon="fas fa-redo"
            value={data.id}
            className="p-button-secondary"
            style={{width: "calc(50% - 0.2rem)"}}
            tooltip={I18N.translate("{$I._app.accessibility.component.fileList.doCancel}")}
            onClick={this._onEditCancel}
            aria-label={I18N.translate("{$I._app.accessibility.component.fileList.doCancel}")}
        /> : null;
    }

    private _actionTemplate(data: any, info: any): React.ReactNode {
        if (this.state.displayMode === ComponentElementDisplayMode.EDIT) {
            const only = !this.state.property.extend.delete && !this.state.property.extend.update;
            return (
                <React.Fragment>
                    {this._actionD(data, info, only)}
                    {this._actionE(data, info)}
                    {this._actionR(data, info)}
                    {this._actionU(data, info)}
                    {this._actionC(data, info)}
                </React.Fragment>
            );
        } else {
            return this._actionD(data, info, true);
        }
    }

    private _search(): React.ReactNode {
        if (!this._isGrid && this.state.property.attribute.search.value) {
            const empty = !this.state.lookup || !this.state.lookup.length ? (
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 p-1">
                    &nbsp;
                </div>
            ) : null;
            const category = this.state.lookup && this.state.lookup.length ? (
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 p-1">
                    {this.accessibility ?
                        <AccessibilityDropdown
                            key="dropdown"
                            value={this.state.category}
                            options={this.state.lookup}
                            placeholder="Select a Category"
                            showClear={false}
                            isMultiple={false}
                            onChange={this._onCategory}
                        /> : <Dropdown
                            key="dropdown"
                            value={this.state.category}
                            options={this.state.lookup}
                            appendTo={DomHelper.getForOverLayDom()}
                            onChange={this._onCategory}
                            placeholder="Select a Category"
                            filter={true}
                            filterBy="label,value"
                        />
                    }
                </div>
            ) : null;
            return (
                <div key={this.elementId + "_search"} className="w-100 row m-0 p-0">
                    {empty}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 p-1">
                        <InputText
                            key="name"
                            value={this.state.name}
                            placeholder="Enter a file name..."
                            onChange={this._onName}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 p-1">
                        <InputText
                            key="title"
                            value={this.state.title}
                            placeholder="Enter a title..."
                            onChange={this._onTitle}
                        />
                    </div>
                    {category}
                    <div className="col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2 p-1 text-right">
                        <Button
                            key="search"
                            icon="fas fa-search"
                            className="p-button-primary"
                            style={{width: "calc(33% - 0.2rem)", marginRight: "0.2rem"}}
                            tooltip="Search"
                            onClick={this._onSearch}
                        />
                        <Button
                            key="clear"
                            icon="fas fa-trash-alt"
                            className="p-button-secondary"
                            style={{width: "calc(33% - 0.2rem)", marginRight: "0.2rem"}}
                            tooltip="Clear Search"
                            onClick={this._onClear}
                        />
                        <Button
                            key="reload"
                            icon="fas fa-sync-alt"
                            className="p-button-secondary"
                            style={{width: "calc(33% - 0.2rem)"}}
                            tooltip="Reload"
                            onClick={this._onReload}
                        />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private _onUpdateTitle(e: any) {
        this._makeUpdate(e.target.getAttribute("bf-data-value"), "title", e.target.value);
    }

    private _onUpdateCategory(e: any) {
        this._makeUpdate(e.target.id.substring(e.target.id.lastIndexOf("_") + 1), "category", JSON.stringify(ObjectHelper.getLookUpFormValue(e.target.value, this.state.lookup)));
    }

    private _onUpdateDescription(e: any) {
        this._makeUpdate(e.target.getAttribute("bf-data-value"), "description", e.target.value);
    }

    private _makeUpdate(id: string, field: string, value: string) {
        const data = this._getData(id);
        if (data.id) {
            data[field] = value;
            this.setState({
                fileList: this.state.fileList
            });
        }
    }

    private async _onGridUpdate(list?: any): Promise<void> {
        if (this._isGrid) {
            const result = [];
            for (const key in list) {
                delete (list[key].RESULT);
                delete (list[key].activitySequence);
                delete (list[key].ROW_NUMBER);
                delete (list[key].version);
                delete (list[key].caseId);
                delete (list[key].workitemSequence);
                result.push(list[key]);
            }
            this.emit(ObjectHelper.jsonCloneDeep(result));
            await FunctionHelper.timeout(200);
            GridActionService.callAction(this.applicationId, this.formId, "Run" + DoGridAction.UPDATE, this.parentDom, (this as any).___props);
            this._onReload();
            BlockHandler.unload(this.elementId);
        }
    }

    private _onTitle(e: any) {
        this.setState({
            title: e.target.value
        });
    }

    private _onName(e: any) {
        this.setState({
            name: e.target.value
        });
    }

    private _onCategory(e: any) {
        this.setState({
            category: e.target.value
        });
    }

    private _onSearch() {
        this._onReload();
    }

    private _onClear() {
        this.setState({
            category: null,
            title: "",
            name: "",
            pageNo: 1
        }, this._onReload);
    }

    private _onReload() {
        if (window[WindowKey.DESIGNMODE] || !window[WindowKey.PROCID]) {
            return;
        }
        if (!this._isGrid && this.state.property && this.state.property.extend && this.state.property.extend.list) {
            BlockHandler.load(this.elementId, this.parentDom);
            ApiFile.getList({
                queryString: FormStateService.getQueryString(this.applicationId, this.formId),
                projectId: this.applicationId,
                formId: this.formId,
                dataEntityId: (this as any).___props.data.dataField,
                LIKE_title_LIKE: this.state.title,
                LIKE_name_LIKE: this.state.name,
                categoryValue: this.state.category,
                pageSize: this.state.property.attribute.rows.value,
                pageNo: this.state.pageNo,
                ORDER_BY: this.state.orderBy
            }, this.state.property.extend.list).then(
                this._successList
            ).catch(
                this._catchException
            );
        } else {
            BlockHandler.load(this.elementId, this.parentDom);
            const props = (this as any).___props;
            if (props.grid && props.grid.pk && !props.grid.forced) {
                let data = GridDataService.getValue(this.applicationId, this.formId, props.data.dataField, props.grid);
                data = data ? data : [];
                this._successList({
                    data: data,
                    pageNo: this.state.pageNo ? this.state.pageNo : 1,
                    totalCount: data.length
                });
            }
            BlockHandler.unload(this.elementId);
        }
    }

    private _successList(res: ResponseFileGetList | any) {
        if (res && Array.isArray(res.data)) {
            // let num;
            // if (this.state.property.attribute.paginator.value) {
            //     num = res.totalCount - (this.state.property.attribute.rows.value * (res.pageNo - 1));
            // } else {
            //     num = res.totalCount;
            // }
            // for (let i = 0 ; i < res.data.length; i++) {
            //     res.data[i].num = num;
            //     num--;
            // }
            if (!res.data.length && res.totalCount) {
                BlockHandler.unload(this.elementId);
                this.setState({
                    pageNo: 1,
                    first: 0
                }, this._onReload);
                return;
            }
            this.setState({
                fileList: res.data,
                pageNo: res.pageNo,
                totalCount: res.totalCount
            }, this._doneReload);
        } else {
            this.setState({
                fileList: [],
                pageNo: 1,
                totalCount: 0
            }, this._doneReload);
        }
    }

    private _successDelete(id: string, response?: any) {
        if (this._isGrid) {
            this._onGridUpdate(response).then();
        } else {
            BlockHandler.unload(this.elementId);
            this.emit({deleteId: id});
            this._onReload();
        }
    }

    private _successUpdate(response?: any) {
        if (this._isGrid) {
            this._onGridUpdate(response).then();
        } else {
            BlockHandler.unload(this.elementId);
            (response as any).modifyId = response.id;
            this.emit(response);
            this._setData(response.id, "edit");
        }
    }

    private _catchException(e: WrongRequest) {
        ExceptionHandler.toast(ExceptionType.ALERT, e);
        this._doneReload();
    }

    private _catchCommonException(e: WrongRequest) {
        BlockHandler.unload(this.elementId);
        ExceptionHandler.toast(ExceptionType.ALERT, e);
    }

    private _doneReload() {
        BlockHandler.unload(this.elementId);
        if (typeof this._lCallback === "function") {
            this._lCallback();
        }
    }

    private _onSort(e: {sortField: string, sortOrder: number, multiSortMeta?: any}) {
        this.setState({
            sortField: e.sortField,
            sortOrder: e.sortOrder,
            orderBy: e.sortField + (e.sortOrder === 1 ? " ASC" : " DESC")
        }, this._onReload);
    }

    private _onPage(e: {first: number, rows: number, page: number, pageCount: number}) {
        this.setState({
            pageNo: e.page + 1,
            first: e.first
        }, this._onReload);
    }

    private _onEdit(e: any) {
        this._setData(e.target.value || e.target.parentElement.value, "edit");
    }

    private _onEditCancel(e: any) {
        this._setData(e.target.value || e.target.parentElement.value, "cancel");
    }

    private _onUpdate(e: any) {
        const data = this._getData(e.target.value || e.target.parentElement.value);
        if (data.id) {
            let result = (response: any) => {
                if (!this._isGrid) {
                    let body: any = {
                        id: data.id,
                        title: data.title,
                        fileSize: data.fileSize,
                        name: data.name
                    };
                    if (data.category) {
                        body.category = data.category;
                    }
                    if (data.description) {
                        body.description = data.description;
                    }
                    this._successUpdate(body);
                    body = null;
                } else {
                    this._successUpdate(response);
                }
                (result as any).__proto__ = null;
                result = null;
            };
            BlockHandler.load(this.elementId, this.parentDom);
            const req: RequestFileUpdate = {
                queryString: FormStateService.getQueryString(this.applicationId, this.formId),
                id: data.id,
                projectId: this.applicationId,
                formId: this.formId,
                title: data.title,
                category: data.category,
                description: data.description,
            };
            if (this._isGrid) {
                req.listRowPk = req.rowPk = (this as any).___props.grid.pk;
                req.listDataEntityId = (this as any).___props.grid.dataField;
            }
            ApiFile[this._isGrid ? "gUpdate" : "update"](req, this.state.property.extend.update).then(
                result
            ).catch(
                this._catchCommonException
            );
        }
    }

    private _onDownload(e: any) {
        if (e.key && e.key !== "Enter") {
            return;
        }
        const id = e.target.getAttribute("bf-data-value") || (e.target.value || e.target.parentElement.value);
        const data = this._getData(id);
        if (data.uri) {
            if (window["$B"].basicWIHActionClient) {
                if (!document.querySelector(`iframe[name="${DataStorage.uniqueAppName}"]`)) {
                    const iframe = document.createElement("iframe");
                    iframe.name = DataStorage.uniqueAppName;
                    iframe.style.display = "none";
                    document.body.appendChild(iframe);
                }
                window.open(DataStorage.path.replace(/\/$/, "") + data.uri, DataStorage.uniqueAppName);
            } else {
                location.href = DataStorage.path.replace(/\/$/, "") + data.uri;
            }
        }
    }

    private _onDelete(e: any) {
        const id = e.target.getAttribute("bf-data-value") || (e.target.value || e.target.parentElement.value);
        if (id) {
            ExceptionHandler.confirm(ExceptionType.INFO, I18N.translate("{$I._app.accessibility.component.fileList.confirmDelete}"), (result: boolean) => {
                if (result) {
                    BlockHandler.load(this.elementId, this.parentDom);
                    this._doDelete(id);
                }
            });
        }
    }

    private _doDelete(id: string) {
        let result = (response: any) => {
            this._successDelete(id, response);
            (result as any).__proto__ = null;
            result = null;
        };
        const qs = FormStateService.getQueryString(this.applicationId, this.formId);
        ApiFile[this._isGrid ? "gDelete" : "delete"](this._isGrid ? {queryString: qs, ids: [id], listRowPk: (this as any).___props.grid.pk, listDataEntityId: (this as any).___props.data.dataField} : {queryString: qs, id: id}, this.state.property.extend.delete).then(
            result
        ).catch(
            this._catchCommonException
        );
    }

    private _getData(id: string) {
        for (let i = 0; i < this.state.fileList.length; i++) {
            if (id === String(this.state.fileList[i].id)) {
                return this.state.fileList[i];
            }
        }
        return null;
    }

    private _setData(id: string, field: string) {
        for (let i = 0; i < this.state.fileList.length; i++) {
            if (field === "edit") {
                this.state.fileList[i]["_" + field] = id === String(this.state.fileList[i].id) ? true : false;
                if (this.state.fileList[i]["_" + field]) {
                    this._editData = {
                        title: this.state.fileList[i].title,
                        category: this.state.fileList[i].category,
                        description: this.state.fileList[i].description
                    };
                }
            } else if (id === String(this.state.fileList[i].id)) {
                this.state.fileList[i]._edit = false;
                this.state.fileList[i].title = this._editData.title;
                this.state.fileList[i].category = this._editData.category;
                this.state.fileList[i].description = this._editData.description;
                delete(this._editData);
                break;
            }
        }
        this.setState({
            fileList: this.state.fileList
        });
    }

    private _clearCallback() {
        if (this._lCallback) {
            (this._lCallback as any).__proto__ = null;
            this._lCallback = null;
        }
    }

    private _initCallback(event: ComponentElementPropertyEvent) {
        const keys = Object.keys(event);
        if (keys && keys.length) {
            for (let i = 0; i < keys.length; i++) {
                let action = StringHelper.makePrintableFunctionStringArray(event[keys[i]].action)[1].trim();
                let state = event[keys[i]].formState ? event[keys[i]].formState.trim() : null;
                let cMessage = event[keys[i]].confirmMessage ? event[keys[i]].confirmMessage.trim() : null;
                if (action || state) {
                    let a = action ? FunctionHelper.stringToFunction(event[keys[i]].action) : null;
                    let s = state ? JSON.parse(state) : null;
                    this["_" + keys[i]] = () => {
                        if (cMessage) {
                            ExceptionHandler.confirm(ExceptionType.INFO, cMessage, (result) => {
                                if (result) {
                                    if (state) {
                                        FormStateService.mergeState(this.applicationId, this.formId, this.elementId, s);
                                    }
                                    if (action) {
                                        a({target: this._element});
                                    }
                                }
                            });
                        } else {
                            if (state) {
                                FormStateService.mergeState(this.applicationId, this.formId, this.elementId, s);
                            }
                            if (action) {
                                a({target: this._element});
                            }
                        }
                    };
                }
            }
        }
    }
}
